import { Component, OnInit } from '@angular/core';
import { AdvisorData, BrandingService, CompanyBrandingHelper, getVerificationFailedGeneralMessage, getVerificationFailedGeneralTitle, IdentityVerificationResultState, IdentityVerificationResultStateHelper } from 'common';
import { EntityFacade } from '../../../entity/domain/+state/entity.facade';
import { combineLatest, Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';

@UntilDestroy()
@Component({
    selector: 'ifp-verify-identity-result',
    templateUrl: './verify-identity-result.component.html',
    styleUrls: ['./verify-identity-result.component.scss'],
    standalone: false
})
export class VerifyIdentityResultComponent implements OnInit {
  title: string;
  message: string;
  messageHtml: string;

  constructor(
    private readonly entityFacade: EntityFacade,
    private readonly brandingService: BrandingService,
    private readonly router: Router,
  ) { }

  ngOnInit(): void {
    const state = IdentityVerificationResultStateHelper.get();

    this.initTitle(state);
    this.initMessage(state);
  }

  private initTitle(state: IdentityVerificationResultState | null): void {
    this.title = state?.title || getVerificationFailedGeneralTitle;
  }

  private initMessage(state: IdentityVerificationResultState | null): void {
    if (state?.message) {
      this.message = state.message;
      this.messageHtml = undefined;
      return;
    }

    this.getDefaultMessage()
      .pipe(untilDestroyed(this))
      .subscribe((message: string) => {
        this.message = undefined;
        this.messageHtml = message;
      });
  }

  private getDefaultMessage(): Observable<string> {
    return this.getAdvisorData().pipe(
      map(advisorData => getVerificationFailedGeneralMessage(advisorData))
    );
  }

  private getAdvisorData(): Observable<AdvisorData> {
    return combineLatest([
      this.entityFacade.getEntity$(null),
      this.brandingService.getBranding$()
    ]).pipe(
      untilDestroyed(this),
      map(([entity, branding]) => {
        return {
          fullName: entity?.advisorName,
          email: entity?.advisorEmail,
          phone: CompanyBrandingHelper.getAdvisorPhone(branding, entity?.advisorPhone)
        };
      }));
  }

  onClosePage(): void {
    this.router.navigate(['sign-out']);
  }
}
